import { FC, ReactNode, SyntheticEvent } from 'react'

type ModalOverlayProps = {
  onClose: () => void
  children: ReactNode
}

const ModalOverlay: FC<ModalOverlayProps> = ({ children, onClose }) => {
  const handleCloseClick = (e: SyntheticEvent) => {
    e.preventDefault()
    onClose()
  }

  return (
    <div
      className="fixed left-0 top-0 right-0 bottom-0 z-999 flex justify-center items-center"
      style={{
        background: 'rgba(15, 20, 30, 0.8)',
      }}
      onClick={handleCloseClick}
    >
      {children}
    </div>
  )
}

export default ModalOverlay
